import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { MessagesSquare } from 'lucide-react';
import { useState } from 'react';
import { GroupSheet } from '~/features/team-chat/GroupSheet';
import { NewDmDialog } from '~/features/team-chat/NewDmDialog';
import { Button } from '~/ui/Button';

export const Route = createFileRoute('/_app/chat/')({
  component: PickAChat,
});

/** What the middle pane says at desktop width before a chat is picked. On a phone the list is the page. */
function PickAChat() {
  const navigate = useNavigate();
  const [newDm, setNewDm] = useState(false);
  const [newGroup, setNewGroup] = useState(false);
  const openChat = (id: string) => void navigate({ to: '/chat/$id', params: { id } });
  return (
    <div className="hidden h-full flex-1 flex-col items-center justify-center gap-3 px-6 text-center md:flex">
      <MessagesSquare size={32} aria-hidden className="text-ink-3" />
      <p className="font-medium">Pick a chat on the left, or start one.</p>
      <div className="flex gap-2">
        <Button variant="secondary" size="sm" onClick={() => setNewDm(true)}>
          New message
        </Button>
        <Button variant="quiet" size="sm" onClick={() => setNewGroup(true)}>
          New group
        </Button>
      </div>
      <NewDmDialog
        open={newDm}
        onClose={() => setNewDm(false)}
        onOpened={openChat}
        onNewGroup={() => setNewGroup(true)}
      />
      <GroupSheet open={newGroup} onClose={() => setNewGroup(false)} onCreated={openChat} />
    </div>
  );
}
